import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import BaseCardCore from 'apps/notificationCenter/views/baseCardCore';

export default withNamespaces()(
  inject('routerStore', 'headerStore')(observer(BaseCardCore)),
);
